import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Droppable } from 'react-beautiful-dnd';
import { Avatar, Tag, Tooltip, Row, Col } from 'antd';

import { IReduxState } from 'src/store';

import Card from './components/card/card.component';

import { IProps } from './list.type';
import { List, ListTitle, ListBody, Toggle } from './list.style';
import { stageTranslation } from 'src/utils/constants/tasks';
import { ICard } from 'src/interfaces/board';

const ListComponent: React.FC<IProps> = (props) => {
  const { list, listId } = props;

  const [counter, setCounter] = useState([0, 0, 0, 0, 0, 0]);
  const [loading, setLoading] = useState(true);

  const cardsById: ICard[] = useSelector(
    (state: IReduxState) => state.board.cardsById
  );

  useEffect(() => {
    async function handleCounter(cards: [number]) {
      setLoading(true);

      const data = [0, 0, 0, 0, 0, 0];

      try {
        for await (let _id of cards) {
          const index = Number(cardsById[_id]?.stage);
          data[index] += 1;
        }
      } finally {
        setCounter(data);
        setLoading(false);
      }
    }

    handleCounter(list.cards);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list.cards]);

  return (
    <List>
      <ListTitle>
        {Number(listId) !== 0 && (
          <Avatar
            style={{
              color: '#4174b4',
              backgroundColor: '#d6e5ec',
              borderColor: '#4174b4',
            }}
            className="me-2"
          >
            {list.title[0]}
          </Avatar>
        )}
        {list.title}
      </ListTitle>

      <Droppable droppableId={list._id}>
        {(provided: any, _snapshot: any) => (
          <ListBody ref={provided.innerRef}>
            {list?.cards &&
              list?.cards.map((cardId: string, index: number) => (
                <Card
                  key={cardId}
                  cardId={cardId}
                  index={index}
                  listId={list._id}
                  handleReload={props.handleReload}
                />
              ))}

            {provided.placeholder}
          </ListBody>
        )}
      </Droppable>

      <Toggle>
        {Number(listId) !== 0 ? (
          <Row gutter={8} align="middle" justify="space-between">
            <Col span={24} className="mb-1">
              <small>
                <b>Total por estágio: </b>
              </small>
            </Col>

            {!loading
              ? stageTranslation.map((item: any) => (
                  <Col>
                    <Tooltip title={item.label}>
                      <Tag
                        icon={item.icon}
                        color={item.color}
                        className="my-1"
                        bordered={false}
                      >
                        <b>{counter[item.value] || 0}</b>
                      </Tag>
                    </Tooltip>
                  </Col>
                ))
              : 'Contabilizando...'}
          </Row>
        ) : (
          <small>
            <b>OS</b> com os operadores técnicos não designados:{' '}
            <Tag className="my-1" bordered={false}>
              <b>{list?.cards.length}</b>
            </Tag>
          </small>
        )}
      </Toggle>
    </List>
  );
};

const mapStateToProps = (state: IReduxState, ownProps: IProps) => ({
  list: state.board.listsById?.[ownProps.listId],
});

export default connect(mapStateToProps)(ListComponent);
